import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-material-icons-page-configurator',
	templateUrl:'./MaterialIconsPageConfiguratorPluginCompPage.html',
	styles: [],
	styleUrls:['./MaterialIconsPageConfiguratorPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class MaterialIconsPageConfiguratorPluginCompPage
{
	mdContent_1075 = `\`\`\`java
import com.jwebmp.plugins.materialicons.MaterialIconsPageConfigurator;
\`\`\``;
	mdContent_1076 = `\`\`\`java
module com.myapp {
    requires com.jwebmp.plugins.materialicons;
}
\`\`\``;
}
